module.exports = __webpack_public_path__ + "static/img/resoce_red.e1a3848.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resoce_red.png
// module id = 89S8
// module chunks = 21